'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/number-is-nan/index.js
// module id = 299
// module chunks = 0